/* eslint-disable unicorn/filename-case -- TODO rename later */
import { refreshAccessToken } from "@istari-frontend/auth";
import { SidebarProvider, Toaster } from "@istari-frontend/ui";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Outlet } from "react-router";

import { UploadAnnouncementSubscriber } from "~/resource/feature/upload-announcement-subscriber";
import { OwnedAuthProvider } from "~/session/feature/session-provider";

import "./App.css";
import { useFontSize } from "./hooks/use-font-size";
import AuthErrorBoundary from "./pages/Authentication/AuthErrorBoundary";
import { useColorTheme } from "./theming/feature/use-color-theme";

function App() {
  useFontSize();
  useColorTheme();

  return (
    <OwnedAuthProvider>
      <ProactiveTokenRefresh />
      <AuthErrorBoundary>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="istari-theme-preference">
          <SidebarProvider defaultOpen={true}>
            <Outlet />
            <Toaster />
            <UploadAnnouncementSubscriber />
          </SidebarProvider>
        </ThemeProvider>
      </AuthErrorBoundary>
    </OwnedAuthProvider>
  );
}

export default App;

/**
 * Renews the access token shortly before expiry. Replaces the UserManager's
 * automaticSilentRenew, which renews per tab and so races other tabs over
 * single-use rotating refresh tokens.
 */
function ProactiveTokenRefresh() {
  const auth = useAuth();

  useEffect(() => auth.events.addAccessTokenExpiring(() => void refreshAccessToken()), [auth.events]);

  return null;
}
